import { supabase } from './supabaseClient';

export async function fetchNews() {
  console.log('Fetching news...');
  const { data, error } = await supabase
    .from('news_english')
    .select('*')
    .order('created_at', { ascending: false });

  if (error) {
    console.error('Supabase error:', error);
    throw error;
  }
  
  console.log('Fetched news:', data);
  return data;
}

export async function fetchNewsByCategory(category: string) {
  const { data, error } = await supabase
    .from('news')
    .select('*')
    .eq('category', category)
    .eq('published', true)
    .order('date', { ascending: false });

  if (error) throw error;
  return data;
}

export async function createNews(newsData: {
  title: string;
  content: string;
  imageUrl?: string;
}) {
  const slug = newsData.title
    .toLowerCase()
    .replace(/[æå]/g, 'a')
    .replace(/[ø]/g, 'o')
    .replace(/[^a-z0-9]+/g, '-')
    .replace(/^-+|-+$/g, '');

  const { data, error } = await supabase
    .from('news')
    .insert([
      {
        title: newsData.title,
        content: newsData.content,
        imageUrl: newsData.imageUrl,
        slug
      }
    ])
    .select()
    .single();

  if (error) throw error;
  return data;
}
